import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from '../../../../app/store';
import { Page } from '../../app';
import { setSearchQuery } from '../../App.slice';

export default function useSearchQuery() {
  const history = useHistory();
  const dispatch = useDispatch();
  const searchMap = useSelector((state: RootState) => state.app.searchQuery);

  let pageKey: Page = 'results';
  let placeholder: string = 'Enter Horse or Rider name';

  switch (history.location.pathname) {
    case '/all-events':
      pageKey = 'allEvents';
      placeholder = 'Enter Event name or Discipline';
      break;
    case '/feed':
      pageKey = 'summary';
      placeholder = 'Enter Class Number or Part of Class Name';
      break;
  }

  const changeQuery = (value: string) => {
    dispatch(setSearchQuery([pageKey, value]));
  }

  return { searchQuery: searchMap[pageKey], changeQuery, placeholder };
}
